import { Box, Tab, Tabs } from '@mui/material';
import { ReactNode, SyntheticEvent } from 'react';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';
import { useSearchParams } from 'react-router-dom';
import { clampNegativeToZero } from '@utils/valueTransformers';

const TAB_QUERY_PARAM = 'tab';

export type TabDefinition = {
  label: ReactNode;
  component: ReactNode;
  path: string;
};

type TabViewProps = {
  tabs: TabDefinition[];
  backgroundColor?: string;
  borderBottom?: boolean;
};

export const TabView = ({
  tabs,
  backgroundColor,
  borderBottom = true,
}: TabViewProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = clampNegativeToZero(
    tabs.findIndex(tab => tab.path === searchParams.get(TAB_QUERY_PARAM))
  );

  const handleTabChange = (_: SyntheticEvent, newValue: number) => {
    searchParams.set(TAB_QUERY_PARAM, tabs[newValue]?.path ?? '');
    setSearchParams(searchParams);
  };

  // TODO: commented styles can be used to approximate the mockup. Pending confirmation from design.
  // we may be able to use different components from the UI kit for this.
  return (
    <Box>
      <Box
        sx={{
          borderBottom: borderBottom ? 1 : 'none',
          borderColor: 'divider',
          marginX: '-1.25rem',
        }}
      >
        <Tabs
          value={activeTab}
          sx={{
            // '& [role=tablist]': { gap: '2rem' },
            marginX: '1.25rem',
          }}
          onChange={handleTabChange}
        >
          {tabs.map(tab => (
            <Tab
              key={tab.path}
              // sx={{ padding: 0 }}
              label={tab.label}
            />
          ))}
        </Tabs>
      </Box>
      {tabs.map((tab, index) => (
        <Box
          key={tab.path}
          sx={
            activeTab === index
              ? {
                  paddingX: '1.25rem',
                  paddingY: '1rem',
                  marginX: '-1.25rem',
                  backgroundColor:
                    backgroundColor ??
                    unifiedPlatformColorPalette.lightBackground,
                }
              : { height: 0, overflow: 'hidden', visibility: 'hidden' }
          }
        >
          {tab.component}
        </Box>
      ))}
    </Box>
  );
};
